import React from 'react';
import Hero from './components/sports-calendar/Hero';
import Main from './components/sports-calendar/Main';

const SportsCalendar = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default SportsCalendar;